<script>
import {Table} from 'vxe-table'
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event'
import Sortable from 'sortablejs'
export default {
  name: 'DataGrid',
  extends: Table,
  props: {
    positionResolver: {
      default: ''
    }
  },
  data () {
    return {
      cellGutter: 10,
      maxColWidth: 2000,
      columnAdjusted: false,
      scrollToTop: false
    }
  },
  computed: {
    gridPrintSize () {
      switch (this.size) {
        case 'large':
        case 'medium':
          return 14
        case 'mini':
        default:
          return 12
      }
    },
    gridHtmlStyle () {
      let printSize = this.gridPrintSize
      return `
        body {
          margin: 0;
        }
        body * {
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
        }
        .vxe-table {
          border: 0;
          border-collapse: separate;
          table-layout: fixed;
          text-align: left;
          font-size: ${printSize}px;
          border-spacing: 0;
        }
        .vxe-table.is--print {
          width: 100%;
        }
        td,thead tr:last-child th {
          border-bottom: 1px solid #e8eaec;
        }
        .vxe-table thead tr:first-child th,
        .vxe-table:not(.show--head) tbody tr:first-child td {
          border-top: 1px solid #e8eaec;
        }

        .vxe-table tr td:first-child,
        .vxe-table tr th:first-child {
          border-left: 1px solid #e8eaec;
        }
        .vxe-table {
          border-width: 1px;
        }
        .vxe-table td,
        .vxe-table th {
          border-right: 1px solid #e8eaec;
        }
        .vxe-table thead {
          background-color: #f8f8f9;
        }
        .vxe-table td>div,.vxe-table th>div {
          padding: .5em .4em;
        }
        .col--center {
          text-align: center;
        }
        .col--right {
          text-align: right;
        }
        .col--ellipsis>div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: break-all;
        }
        .vxe-table--tree-node {
          text-align: left;
        }
        .vxe-table--tree-node-wrapper {
          position: relative;
        }
        .vxe-table--tree-icon-wrapper {
          position: absolute;
          top: 50%;
          width: 1em;
          height: 1em;
          text-align: center;
          -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          cursor: pointer;
        }
        .vxe-table--tree-icon {
          position: absolute;
          left: 0;
          top: .3em;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: .5em;
          border-top-color: #939599;
          border-right-color: transparent;
          border-bottom-color: transparent;
          border-left-color: transparent;
        }
        .vxe-table--tree-cell {
          display: block;
          padding-left: 1.5em;
        }
      `
    }
  },
  methods: {
    bindEvents () {
      addResizeListener(this.$el, this.handleGridResize)
    },
    unbindEvent () {
      removeResizeListener(this.$el, this.handleGridResize)
    },
    handleGridResize () {
      this.$nextTick(() => this.recalculate())
    },
    adjustColumnWidth () {
      let columns = this.getTableColumn().fullColumn
      if (columns) {
        const headerWrapper = this.$refs['tableHeader']
        const bodyWrapper = this.$refs['tableBody']
        // 列宽自适应
        columns.forEach(col => {
          if (col.property) {
            let maxWidth = this.maxColWidth
            if (col.own) {
              let getMaxWidth = col.own.$attrs['max-width']
              if (typeof getMaxWidth === 'number' && getMaxWidth > 0) {
                maxWidth = getMaxWidth
              }
            }
            let setWidth = 0
            if (headerWrapper) {
              let cols = headerWrapper.$el.querySelectorAll(`.${col.id}`)
              if (cols && cols.length) {
                cols.forEach(c => {
                  let cell = c.firstChild
                  if (cell) {
                    let scrollWidth = cell.scrollWidth
                    if (cell.firstChild) {
                      let titleWidth = cell.firstChild.scrollWidth
                      if (titleWidth) {
                        scrollWidth = Math.max(scrollWidth, titleWidth + 20)
                      }
                    }
                    if (scrollWidth > cell.clientWidth && scrollWidth < maxWidth) {
                      setWidth = Math.max(setWidth, scrollWidth)
                    }
                  }
                })
              }
            }
            if (bodyWrapper) {
              let cols = bodyWrapper.$el.querySelectorAll(`.${col.id}`)
              if (cols && cols.length) {
                cols.forEach(c => {
                  let cell = c.firstChild
                  if (cell) {
                    let scrollWidth = cell.scrollWidth
                    if (scrollWidth > cell.clientWidth) {
                      setWidth = Math.min(Math.max(setWidth, scrollWidth), maxWidth)
                    }
                  }
                })
              }
            }
            if (setWidth > 0) {
              let fitWidth = setWidth + 2 * this.cellGutter
              let colWidth = col.width || 0
              if (colWidth < fitWidth) {
                col.width = fitWidth
              }
            }
          }
        })
        this.refreshColumn()
      }
    },
    createColumnSort () {
      if (this.columnKey) {
        this.columnSort = Sortable.create(this.$el.querySelector('.body--wrapper>.vxe-table--header .vxe-header--row'), {
          handle: '.vxe-header--column',
          draggable: '.vxe-header--column:not(.col--fixed)',
          onEnd: ({ item, newIndex, oldIndex }) => {
            let { fullColumn, tableColumn } = this.getTableColumn()
            let fromColumn = tableColumn[oldIndex]
            let toColumn = tableColumn[newIndex]
            // 转换真实索引
            let oldColumnIndex = this.getColumnIndex(fromColumn)
            let newColumnIndex = this.getColumnIndex(toColumn)
            if (oldColumnIndex !== newColumnIndex) {
              // 移动到目标列
              let currCol = fullColumn.splice(oldColumnIndex, 1)[0]
              fullColumn.splice(newColumnIndex, 0, currCol)
              this.loadColumn(fullColumn)
              // 发送排序通知
              this.$emit('column-reorder', { fullColumn, fromColumn, toColumn })
            }
          }
        })
      }
    },
    printGrid (opts) {
      this.print(this.$extend({
        style: this.gridHtmlStyle
      }, opts))
    }
  },
  mounted () {
    this.bindEvents()
    this.createColumnSort()
  },
  beforeDestroy () {
    if (this.columnSort) {
      this.columnSort.destroy()
    }
    this.unbindEvent()
  },
  watch: {
    tableData: function (data) {
      if (data && data.length) {
        this.$nextTick().then(() => {
          this.clearCurrentColumn()
          if (!this.columnAdjusted) {
            this.adjustColumnWidth()
            this.columnAdjusted = true
          }
        }).finally(() => {
          if (this.scrollToTop) {
            this.scrollToTop = false
            this.clearScroll().then(() => this.scrollTo(null, 0))
          }
        })
      }
    },
    positionResolver: function () {
      this.scrollToTop = true
    }
  }
}
</script>
